"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const getCampaignType_1 = require("../../../utils/getCampaignType");
const luxon_1 = require("luxon");
const reducers_1 = require("../../../../reducers");
const actions_1 = require("../../../../actions");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const EventPredicateAddEdit_1 = require("./EventPredicateAddEdit");
const dateFormat = { month: 'short', day: '2-digit' };
const EventPredicateList = ({ device, predicate, removePredicate, updateActivePopover, }) => {
    if (getCampaignType_1.isCompoundPredicate(predicate)) {
        const getFullText = (keyPathSelected, displayName) => {
            return (React.createElement("div", { style: Object.assign(Object.assign(Object.assign({ flex: '0 1 auto' }, src_1.text), src_1.regular), { lineHeight: '24px', height: 24, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }) },
                React.createElement("span", null,
                    keyPathSelected,
                    "\u00A0"),
                React.createElement("span", { style: { fontStyle: 'italic', color: src_1.graphite } },
                    displayName,
                    "\u00A0")));
        };
        const renderBadge = (booleanOperator) => {
            return React.createElement(src_1.Badge, { color: src_1.steel, text: booleanOperator });
        };
        const getComparisonDisplayValue = (pred) => Object.keys(pred.value).find((v) => pred.value[v] !== null) !==
            'booleanValue'
            ? reducers_1.getComparisonOperatorDisplayValue(pred.operator)
            : 'is';
        const getPopoverTargetText = (pred) => {
            const { value, operator } = pred;
            const val = Object.values(value).filter((v) => v !== null)[0];
            const valueOperator = Object.keys(value).find((v) => value[v] !== null);
            const outerStyle = Object.assign(Object.assign(Object.assign({ color: src_1.aquamarine, lineHeight: '24px', height: 24 }, src_1.text), src_1.regular), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' });
            const formatText = (v) => {
                if (v === null) {
                    return React.createElement("span", null, "Unknown");
                }
                if (valueOperator === 'dateTimeValue' || valueOperator === 'dateTimeValues') {
                    return (React.createElement("span", null,
                        `${luxon_1.DateTime.fromISO(v.toString(), {
                            setZone: true,
                        }).toLocaleString(luxon_1.DateTime.DATE_MED)}`,
                        React.createElement("span", { style: {
                                color: src_1.charcoal,
                            } }, "\u00A0at\u00A0"),
                        `${luxon_1.DateTime.fromISO(v.toString(), {
                            setZone: true,
                        }).toLocaleString(luxon_1.DateTime.TIME_SIMPLE)}`));
                }
                if (valueOperator === 'listValue') {
                    const list = v;
                    return React.createElement("span", null, list.name);
                }
                return React.createElement("span", null, v.toString());
            };
            if (operator === 'GEO_WITHIN') {
                return (React.createElement("div", { style: outerStyle },
                    React.createElement("span", { style: {
                            color: src_1.aquamarine,
                        } },
                        "\u00A0",
                        `${val[2]}m`),
                    React.createElement("span", { style: {
                            color: src_1.charcoal,
                            fontStyle: 'italic',
                        } }, "\u00A0of"),
                    React.createElement("span", { style: {
                            color: src_1.aquamarine,
                        } },
                        "\u00A0",
                        `${val[0]}, ${val[1]}`)));
            }
            if (valueOperator.includes('Values')) {
                return (React.createElement("div", { style: outerStyle }, val.map((v, index) => (React.createElement(React.Fragment, { key: index },
                    formatText(v),
                    index !== val.length - 1 && (React.createElement("span", { style: {
                            color: src_1.charcoal,
                        } }, ",\u00A0")))))));
            }
            return React.createElement("div", { style: outerStyle },
                formatText(val),
                " ");
        };
        const { predicates, booleanOperator } = predicate;
        return (!!predicate && (React.createElement("div", { style: { overflowY: 'scroll' } }, predicates &&
            predicates.map((predicate, index) => (React.createElement("div", { onClick: () => updateActivePopover(`event-edit-conditions-${index}`), key: index },
                React.createElement(src_1.List, { separationElement: index > 0 ? renderBadge(booleanOperator) : undefined },
                    React.createElement("div", { style: {
                            width: 'calc(100% - 32px)',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        } },
                        React.createElement("div", { style: {
                                display: 'flex',
                            } },
                            predicate.modifier && predicate.modifier !== 'DIRECT' ? (React.createElement("div", { style: {
                                    background: src_1.turquoise,
                                    borderRadius: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 40,
                                    height: 24,
                                    marginRight: 5,
                                } },
                                React.createElement(src_1.Badge, { color: src_1.white, text: predicate.modifier }))) : undefined,
                            getFullText(predicate.keyPath.slice(11), getComparisonDisplayValue(predicate)),
                            React.createElement("div", { style: {
                                    flex: 1,
                                    height: 24,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                } },
                                React.createElement(EventPredicateAddEdit_1.default, { device: device, type: "edit", id: index }, getPopoverTargetText(predicate))))),
                    React.createElement(src_1.CircleCloseIcon, { fill: src_1.silver, onClick: (e) => {
                            e.stopPropagation();
                            removePredicate(index);
                        } }))))))));
    }
    return null;
};
const mapStateToProps = (state) => ({
    predicate: reducers_1.getEditableEventAttributesEventTriggerFilter(state),
});
const mapDispatchToProps = (dispatch) => ({
    removePredicate: (index) => dispatch(actions_1.removePredicate(index)),
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventPredicateList);
